import { gql, useMutation } from '@apollo/client'
import { IForumTopic, IForumTopicCreateInput } from '@dtos/Comment'

export const FORUM_TOPIC_CREATE = gql`
  mutation ForumTopicCreate(
    $courseContentId: ID!
    $title: String!
    $description: String
  ) {
    forumTopicCreate(
      input: {
        courseContentId: $courseContentId
        title: $title
        description: $description
        clientMutationId: "forum-topic-create"
      }
    ) {
      topic {
        id
        title
        description
        fixed
        answered
        answeredAt
        postsCount
        createdAt
        courseContentId
        user {
          id
          fullName
          firstName
          lastName
          email
          avatarUrl
        }
      }
      errors
    }
  }
`

interface IForumTopicCreateResult {
  forumTopicCreate: {
    topic: IForumTopic | null
    errors: string[]
  }
}

export const useForumTopicCreate = () => {
  const [createTopic, { loading, error }] =
    useMutation<IForumTopicCreateResult>(FORUM_TOPIC_CREATE, {
      refetchQueries: ['GetForumTopics'],
      awaitRefetchQueries: true,
    })

  const handleCreateTopic = async (input: IForumTopicCreateInput) => {
    const response = await createTopic({ variables: input })
    return response.data?.forumTopicCreate
  }

  return { handleCreateTopic, loading, error }
}
